// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2AXWV","inputWrap":"Table_inputWrap__2-U4v","col":"Table_col__1hALp","bmiTooltip":"Table_bmiTooltip__1FNDO"};